import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import ExpandableParagraph from 'components/common/expandable_paragraph'
import Linkify from 'react-linkify'
import cssModules from 'react-css-modules'
import styles from './campaign_details.less'
import { Avatar, Col, Row, CaptionText } from '@paypalcorp/pp-react'

const i18n = getI18n('components/campaign_details')
const i18nCharity = getI18n('components/crowdfunding_charity_detail_view')
const MAX_ROWS = 200
const DEFAULT_ROWS = 3

class CampaignDetails extends React.Component {
  static propTypes = {
    details: PropTypes.string,
    tab_layout: PropTypes.bool,
    profileImage: PropTypes.string,
    initials: PropTypes.string,
    isCharity: PropTypes.bool,
    charity: PropTypes.any,
    isPreview: PropTypes.bool,
    ownerName: PropTypes.string,
  }
  static defaultProps = {
    tab_layout: false,
  }
  render() {
    if (!this.props.details) {
      return null
    }
    let title
    if (this.props.isCharity) {
      title = i18nCharity('about_fundraiser')
    } else {
      title = this.props.tab_layout ? '' : i18n('title')
    }
    const titleStrong = this.props.isCharity
    const maxRows = this.props.tab_layout ? MAX_ROWS : DEFAULT_ROWS

    return (
      <React.Fragment>
        {this.props.isCharity && (
          <Row styleName="charityOrganiserDetailsContainer">
            <Col styleName="charityOrganiserAvatarContainer">
              <Avatar
                src={this.props.profileImage}
                initials={this.props.initials}
                size="xs"
                alt="fundraiser creator profile image"
              />
            </Col>
            <Col styleName="charityOrganiserDetails">
              <div>
                <CaptionText>
                  {i18nCharity('raising_charity_fund_for', {
                    creatorFullName: this.props.ownerName,
                    supportingCharityName: this.props.charity.name,
                  })}
                </CaptionText>
              </div>
            </Col>
          </Row>
        )}
        <div styleName="details-margin">
          <ExpandableParagraph
            titleText={title}
            maxRows={maxRows}
            titleStrong={title}
            customClass="margin-bottom-32"
          >
            <Linkify properties={{ target: '_blank' }}>
              {this.props.details}
            </Linkify>
          </ExpandableParagraph>
        </div>
        <div styleName="details-margin">
          {this.props.isCharity && (
            <ExpandableParagraph
              titleText={i18nCharity('about_charity')}
              maxRows={maxRows}
              titleStrong={titleStrong}
            >
              <Linkify properties={{ target: '_blank' }}>
                {this.props.charity.description}
              </Linkify>
            </ExpandableParagraph>
          )}
        </div>
      </React.Fragment>
    )
  }
}

export default cssModules(CampaignDetails, styles, { allowMultiple: true })
